import { render, staticRenderFns } from "./WholesaleSelector.vue?vue&type=template&id=6f4d0019&scoped=true&"
import script from "./WholesaleSelector.vue?vue&type=script&lang=ts&"
export * from "./WholesaleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./WholesaleSelector.vue?vue&type=style&index=0&id=6f4d0019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d0019",
  null
  
)

export default component.exports